(function () {
  'use strict';

  (function () {
    new themegoal.helpers.Responsive();
    new TG_ProductCardColorSwatch();
    let windowWidth = window.innerWidth;
    let pageHeader = document.getElementById('PageHeader');
    if (pageHeader) {
      document.documentElement.style.setProperty('--tg-page-header-height', pageHeader.offsetHeight + 'px');
    }
    window.addEventListener('resize', function () {
      let newWidth = window.innerWidth;

      if (newWidth === windowWidth) {
        return;
      }

      let headerSection = document.getElementById('Header');
      let announcementBarSection = document.getElementById('AnnouncementBar');
      windowWidth = newWidth;
      document.documentElement.style.setProperty('--tg-window-height', window.innerHeight + 'px');

      if (headerSection) {
        document.documentElement.style.setProperty('--tg-header-height', headerSection.offsetHeight + 'px');
      }

      if (announcementBarSection) {
        document.documentElement.style.setProperty('--tg-announcement-bar-height', announcementBarSection.offsetHeight + 'px');
      }

      if (pageHeader) {
        document.documentElement.style.setProperty('--tg-page-header-height', pageHeader.offsetHeight + 'px');
      }
    });
  })();

(function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
})(window, document, "clarity", "script", "tc0vafa2av");


})();

class PopupTrigger extends HTMLElement {
  constructor() {
    super();  

    this.popupId = this.dataset.popupId;
    this.popupOverlay = document.querySelector(`div.popup__overlay[data-popup-id="${this.popupId}"]`);
    this.popup = this.popupOverlay?.querySelector('.popup__content');
    this.closeButton = this.popup?.querySelector('.header__icon-close');
  }

  connectedCallback() {
    if (!this.popupOverlay || !this.popup) {
      console.warn(`Popup with id "${this.popupId}" not found.`);
      return;
    }

    this.addEventListener('click', this.openPopup.bind(this));

    this.popupOverlay.addEventListener('click', this.closePopup.bind(this));

    this.popup.addEventListener('click', (event) => {
      event.stopPropagation();
    });    

    if (this.closeButton) 
      this.closeButton.addEventListener('click', this.closePopup.bind(this));
  }

  disconectedCallback() {
    this.removeEventListener('click');
    this.popupOverlay.removeEventListener('click')
    this.popup.removeEventListener('click')

    if (this.closeButton) 
      this.closeButton.removeEventListener('click')
  }

  openPopup() {
    document.body.style.overflow = 'hidden';
    this.popupOverlay.setAttribute("data-popup-open", "");
  }

  closePopup() {
    document.body.style.overflow = '';
    this.popupOverlay?.removeAttribute("data-popup-open");
  }
}

if(!customElements.get('popup-trigger')) {
  customElements.define('popup-trigger', PopupTrigger);
}

document.addEventListener("DOMContentLoaded", () => {
  const sizeGuideWrapper = document.querySelectorAll('.size-chart-wrapper');

  if(!sizeGuideWrapper) return

  sizeGuideWrapper.forEach((chart, index) => {
    const uid = "chart-" + index;

    const triggers = chart.querySelectorAll('label')
    
    const inchesRadio = chart.querySelector("#unit-inches-radio");
    const cmRadio = chart.querySelector("#unit-cm-radio");

    const inchesLabel = chart.querySelector('label[for="unit-inches-radio"]');
    const cmLabel = chart.querySelector('label[for="unit-cm-radio"]');
    
    if (inchesRadio && inchesLabel) {
      inchesRadio.id = "unit-inches-radio-" + uid;
      inchesRadio.name = "size-unit-" + uid;
      inchesLabel.setAttribute("for", "unit-inches-radio-" + uid);

      if(inchesRadio.getAttribute('checked') != null) {
        inchesLabel.classList.add('unit-option--active')
      }
    }

    if (cmRadio && cmLabel) {
      cmRadio.id = "unit-cm-radio-" + uid;
      cmRadio.name = "size-unit-" + uid;

      cmLabel.setAttribute("for", "unit-cm-radio-" + uid);

      if(cmRadio.getAttribute('checked') != null) {
        cmLabel.classList.add('unit-option--active')
      }
    }

    triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        triggers.forEach(item => item.classList.remove('unit-option--active'))
      }, { once: true })
    })
  })
})


if (!customElements.get('product-card-carousel')) {
  customElements.define('product-card-carousel', class TG_Collection_ImageWrapper extends HTMLElement{
    constructor() {
      super();
      this.hasAppendedRemainingImages = false;
    }

    connectedCallback() {
      if (!this.closest('section-collection')) {
        // return;
      }

      this.remainingImages = this.parseRemainingImages();

      if (!this.remainingImages.length) {
        return;
      }

      this.addEventListener('scroll', this.handleFirstScroll, { passive: true, once: true });
    }

    parseRemainingImages() {
      const dataElement = this.querySelector('.product-card-carousel-json');

      if (!dataElement) {
        return [];
      }

      try {
        return JSON.parse(dataElement.textContent);
      } catch (error) {
        console.error('Failed to parse product card carousel JSON:', error);
        return [];
      }
    }

    handleFirstScroll = () => {
      if (this.hasAppendedRemainingImages) {
        return;
      }

      this.hasAppendedRemainingImages = true;
      this.appendRemainingImages();
    }

    appendRemainingImages() {
      const firstItem = this.querySelector('.carousel-item');

      if (!firstItem) {
        return;
      }

      this.remainingImages.forEach((imageData) => {
        const carouselItem = firstItem.cloneNode(true);
        const image = carouselItem.querySelector('img');
        const loader = carouselItem.querySelector('.Image--loader');

        carouselItem.setAttribute('href', this.dataset.productUrl || firstItem.getAttribute('href') || '#');

        if (!image) {
          return;
        }

        image.src = imageData.src;
        image.srcset = imageData.srcset;
        image.sizes = imageData.sizes;
        image.alt = imageData.alt || '';
        image.width = imageData.width;
        image.height = imageData.height;
        image.removeAttribute('data-src');
        image.removeAttribute('data-srcset');

        if (image.classList.contains('Image--withLoader')) {
          if (image.complete) {
            image.classList.add('Image--loaded');
          } else {
            image.addEventListener('load', () => image.classList.add('Image--loaded'), { once: true });
            image.addEventListener('error', () => image.classList.add('Image--loaded'), { once: true });
          }
        }

        if (loader && !image.classList.contains('Image--withLoader')) {
          loader.remove();
        }

        this.appendChild(carouselItem);
      });

      this.querySelector('.product-card-carousel-json')?.remove();
    }
  })
}

document.addEventListener('error', (event) => {
  const image = event.target;

  if (!(image instanceof HTMLImageElement) || !image.classList.contains('ProductCard__Image')) {
    return;
  }

  console.log("image", image)

  const fallbackSrc = image.dataset.fallbackSrc;

  if (!fallbackSrc || image.dataset.fallbackApplied === 'true') {
    return;
  }

  image.dataset.fallbackApplied = 'true';
  image.removeAttribute('srcset');
  image.src = fallbackSrc;
}, true);
